import { PkgDesCatInputs } from "../pages/page-components/page-categories/TabAddPkgCategories";
import { CategoryTranslationFormInputs } from "../types/FormFields";
import httpUtil from "../utils/http.util";

class PkgDestinationCatService {
  async StorePkgDestCat(data: PkgDesCatInputs) {
    // const formData=new FormData()
    return await httpUtil.post("/pkgDestinationCategory/create", data, true);
  }
  async AddTranslation(
    data: CategoryTranslationFormInputs,
    category_id: string,
    lang_id: string
  ) {
    const apiData = {
      category_title: data.category_title,
      pkgDestinationCategory: category_id,
      lang_id,
    };
    return await httpUtil.post(
      "/pkgDestinationCategory/translate/create",
      apiData
    );
  }
  async getTranslation(category_id: string, lang_id: string) {
    return await httpUtil.get(
      `/pkgDestinationCategory/translate/getOne?category_id=${category_id}&lang_id=${lang_id}`
    );
  }

  async updateTranslation(
    translation_id: string,
    data: CategoryTranslationFormInputs
  ) {
    return await httpUtil.patch(
      "/pkgDestinationCategory/translate/update",
      translation_id,
      data
    );
  }

  async getAllPkgDestCat() {
    return await httpUtil.get("pkgDestinationCategory/getAll");
  }
  async deletePkgDestCat(id: string) {
    return await httpUtil.delete("pkgDestinationCategory/delete", id);
  }

  async UpdatePkgDestCat(data: any, id: string) {
    return await httpUtil.patch(
      `/pkgDestinationCategory/update`,
      id,
      data,
      true
    );
  }
}

export default new PkgDestinationCatService();
